export default __webpack_public_path__ + "static/media/projects.2ecdc038.svg";